export const DIRECTION_CHANGE = 'DIRECTION_CHANGE';

export const UPDATE_LANGUAGE_REQUEST = 'UPDATE_LANGUAGE_REQUEST'
export const UPDATE_LANGUAGE_SUCCESS = 'UPDATE_LANGUAGE_SUCCESS'
export const UPDATE_LANGUAGE_FAIL = 'UPDATE_LANGUAGE_FAIL'

export const SET_NAVBAR_HEIGHT = 'SET_NAVBAR_HEIGHT'
export const SET_DASHBOARD_TITLE = 'SET_DASHBOARD_TITLE'
export const SET_CHAT_COUNT = 'SET_CHAT_COUNT'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'